// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"3a0971f5","263":"9f8e6d71","321":"8ecff9ba","357":"6fc7d86f","453":"332a8dfa","783":"f5263686"}[chunkId] + ".chunk.js";
};